import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import DirectionsRepository from '@/js/common/Domain/Repository/Directions';
import RestTypesRepository from '@/js/common/Domain/Repository/RestTypes';

import RestTypesView from './RestType/RestType';
import DirectionsView from './Directions/Directions';
import ToursOnIndexModel from './ToursOnIndexModel';

@extendDecorator({
    el: '.toursCity',
    bindings: {
        '.js-selected-rest-type-label': 'html: selectedRestTypeName',
        '.js-show-all-direction': 'toggle: all(not(showAll), showMoreButtonVisible)',
        '.popularTours_carousel': 'classes: { sliderOn: not(showAll) }',
    },
    events: {
        'click .js-show-all-direction': 'showAllDirection',
    },
})
export default class ToursOnIndex extends Backbone.Epoxy.View {
    showAllDirection(e) {
        e.preventDefault();

        this.model.set('showAll', true);
    }

    updateCollection() {
        this.collection
            .reset(this.model.get('filteredDirectionsWithShowAll')?.models);

        setTimeout(() => {
            this.initTooltips();
        }, 50);
    }

    initTooltips() {
        $('.cityPreview_label .icon')
            .not('.added').addClass('added').tooltip({
            position: {
                using(position, feedback) {
                  $(this).css(position);
                  $('<div>')
                    .addClass('arrow')
                    .addClass(feedback.vertical)
                    .addClass(feedback.horizontal)
                    .appendTo(this);
                },
              },
        });
    }

    initViews() {
        new DirectionsView({
            el: '#directionsTemplate',
            collection: this.collection,
            parentModel: this.model,
            directionsTemplate: this.directionsTemplate,
        });

        new RestTypesView({
            el: '#restTypesTemplate',
            collection: this.bindingSources.restTypesCollection,
            parentModel: this.model,
        });
    }

    initModels(options) {
        this.RestTypesRepository = options?.RestTypesRepository
            ? options.RestTypesRepository
            : RestTypesRepository;

        this.directionsTemplate = options?.directionsTemplate
            ? options.directionsTemplate
            : null;

        this.DirectionsRepository = options?.DirectionsRepository
            ? options.DirectionsRepository
            : DirectionsRepository;

        this.bindingSources = {
            restTypesCollection: new this.RestTypesRepository(),
        };

        this.model = new ToursOnIndexModel({
            directions: this.DirectionsRepository.repository,
        });

        this.collection = new this.DirectionsRepository();

        this.bindingSources
            .restTypesCollection
            .reset(this.RestTypesRepository.repository.models);
    }

    initListeners() {
        this.model.on('change:filteredDirectionsWithShowAll', this.updateCollection.bind(this));
    }

    initialize(options) {
        this.initModels(options);
        this.initViews();
        this.updateCollection();
        this.initListeners();
    }
}
